import React from 'react';
import {Table, InputNumber, Alert, Button} from 'antd';

/**
 * update this.state.name
 * @function: this.props.updateParameters(): the function is called in two places.
 * componentDidUpdate() && save()
 */

const EditableCell = ({editable, value, onChange})=>(
  <div style={{marginRight: '8px'}}>
    {
      editable
      ? <InputNumber style={{margin: '-5px 0'}} 
          min={0}
          max={100}
          step={0.1}
          formatter={value => `${value}%`}
          parser={value => value.replace('%', '')}
          value={value} 
          onChange={onChange} />
      : `${value}%`
    }
  </div>
);

class MyTable extends React.Component{
  constructor(props){
    super(props);

    this.state = { 
        dataSource: [], 
        selectedRows: [],
        editingKey: '', //record which column is being edited
        sumError: false,
        rowChanged: false
    };

    // these two arrays will be compared and merged by saveAll()
    // a local copy to keep tracking of column data changes
    this.savedData = [];

    this.columns = [
      {
        title: 'Tags',
        dataIndex: 'tags',
        key: 'tags',
      },
      {
        title: '% of -2',
        dataIndex: 'minus2',
        key: 'minus2',
        width: '15%',
        className: 'col-minus2',
        render: (text, record)=>{
            // console.log('column re-renderred');
            return this.renderColumns(text, record, 'minus2')
        },
      },
      {
        title: '% of -1',
        dataIndex: 'minus1',
        key: 'minus1',
        width: '15%',
        className: 'col-minus1',
        render: (text, record)=>this.renderColumns(text, record, 'minus1'),
      },
      {
        title: '% of 1',
        dataIndex: 'plus1',
        key: 'plus1',
        width: '15%',
        className: 'col-plus1',
        render: (text, record)=>this.renderColumns(text, record, 'plus1'),
      },
      {
        title: '% of 2',
        dataIndex: 'plus2',
        key: 'plus2',
        width: '15%',
        className: 'col-plus2',
        render: (text, record)=>this.renderColumns(text, record, 'plus2'),
      },
      {
        title: 'Action',
        key: 'action',
        width: '20%',
        className: 'col-action',
        render: (text, record)=>{
          // console.log(record);
          const editable = this.isEditing(record);

          return(
          <div>
          {
            editable
            ?(
              <div>
                <span style={{color: '#108ee9', cursor: 'pointer', marginRight: '10px'}} 
                  onClick={this.save}>Confirm</span>
                <span style={{color: '#108ee9', cursor: 'pointer', }} 
                  onClick={this.cancel}>Cancel</span>
              </div>
            )
            :(
              <span style={{color: '#108ee9', cursor: 'pointer'}}
                onClick={()=>this.edit(record.key)}>Edit</span>
            )
          }
          </div>)
        }
      }
    ];

    // rowSelection object indicates the need for row selection
    this.rowSelection = {
      onChange: (selectedRowKeys, selectedRows)=>{
        // console.log('row selection changed');
        /**
         * selectedRowKeys not reliable if you deselecte a row then modify its parameters
         * the modified row will automatically be added into selectedRows but will give mixed selectedRowKwys
         */

        // console.log(`selected row keys: ${selectedRowKeys}`);
        // console.log(`selected rows: `, selectedRows);

        /******************************************************************************
         * Neither this.savedData nor this.state.dataSource are affect by this
         * ONLY the parent session parameters is updated by this method
         * 
         * Special case handled:
         * If I 'edit' a de-selected row, and click 'save', that row will automatically become 'selected' :) by design
         ******************************************************************************/

        // update the session parameter object
        let _arr = selectedRows.map(item=>({...item}));
        this.setState({selectedRows: _arr});

        if(selectedRows.length > 0){
          this.setState({rowChanged: true});
        }else if (selectedRows.length === 0){
          this.props.updateParameters({
            isobaricList: [],
            isobaricTable: [],
            selectedIsobaricTable: []
          });
          this.setState({rowChanged: false});
        }
      },
    }
  }

  componentDidUpdate(prevPro, prevState){
    // console.log('isobaric component did update');

    // console.log(prevPro); // []
    // console.log(prevState); // default values
    // console.log(this.props); // []
    // console.log(this.state);

    // need to compare obj array here
    // this.props.dataSource is generated && updated from IsobaricTabCheckbox
    let str1 = JSON.stringify(this.props.parameters);
    let str2 = JSON.stringify(prevPro.parameters);

    // upate both savedData and this.state.dataSource once props is updated
    if(str1 !== str2){
      // console.log('difference detected');
      let _data = this.props.parameters.isobaricTable.map(item=>({...item})); 

      // a copy of savedData, which is also updated by save() method
      this.savedData = _data;
      // a copy of selectedRows
      this.selectedRows = this.props.parameters.selectedIsobaricTable.map(item=>({...item}));
      // update local state.dataSource, which can be updated by any input changes and cancel() method
      this.setState({
        dataSource: _data,
      });
    }

    if(prevState.selectedRows.length !== this.state.selectedRows.length){
      this.setState({
        rowChanged: true
      })
    }
  }

  renderColumns(input, record, column){
    const editable = this.isEditing(record);
    return(
      <EditableCell 
        editable={editable}
        value={input}
        onChange={value=>this.handleChange(value, record.key, column)}
      />
    );
  }

  // update user input changes
  handleChange(value, key, column){
    value = this.precise(value);
    // console.log(value);
    //
    // step 1
    // make deep clone of this.state.dataSource into _data
    //
    const _data = this.state.dataSource.map(item=>({...item}));
    //
    // step 2
    // find the index of the editing row
    //
    const row = _data.findIndex(item=>key === item.key);
    // return int row num
    const _pair_row = this.findPairingRow(_data, row);
    // console.log(_pair_row);
    //
    // step 3
    // then setState dataSource from newData
    //
    if(row > -1){
      // 
      // step: 3.1
      // update _data with new input (for both rows)
      // 
      _data[row][column] = value;
      _data[_pair_row][column] = value;
      // 
      // step: 3.2
      // calculate sum of all four columns
      // 
      let sum = parseFloat(_data[row]['minus1']) + parseFloat(_data[row]['minus2']) + parseFloat(_data[row]['plus1']) + parseFloat(_data[row]['plus2']);
      // console.log(sum);
      // 
      // step 3.3
      // decide if state.dataSource should be updated
      // 
      if(sum > 100){
        this.setState({sumError: true})
      }else{
        // update state.dataSource
        this.setState({dataSource: _data});
      }
    }
  }

  // use by @function: handleChange()
  // input current dataSource arr && editing row number
  // output the pairing row number based on the editing row
  findPairingRow = (arr, _rowNum) => {

    let str1 = arr[_rowNum].tags;
    let sub_str2 = str1.slice(0, str1.indexOf('-')); 
    // console.log(sub_str2); // "iTRAQ4plex"

    // cut string to get "-Nter" || "-Lys" and return pairing row number
    if(str1.includes("-Nter")){
      // obtain the string for comparison
      let sub_str1 = str1.slice(str1.indexOf('-')+5);
      ;
      // console.log(sub_str1); // "128C" or "128"
      return arr.findIndex(item=>item.tags === `${sub_str2}-Lys${sub_str1}`);
    }else if(str1.includes("-Lys")){
      // obtain the string for comparison
      let sub_str1 = str1.slice(str1.indexOf('-')+4);
      // console.log(sub_str1); // // "128C" or "128"
      return arr.findIndex(item=>item.tags === `${sub_str2}-Nter${sub_str1}`);
    }else{
      // simply return the input row num
      return _rowNum;
    }
  }

  // update state.dataSource from saveData
  cancel = () => {
    // deep clone this.savedData
    const _data = this.savedData.map(item=>({...item}));
    // console.log(_data);
    this.setState({
      dataSource:_data,
      editingKey: '',
      sumError: false
    });
  };

  // update saveData from state.dataSource
  save = () => {
    // update savedData
    this.savedData = this.state.dataSource.map(item=>({...item}));

    this.setState({
      editingKey: '',
      sumError: false,
      rowChanged: true
    });
  }
  
  // activate editing
  edit = (key) => {
    this.setState({ editingKey: key });
  }

  // helper functions
  isEditing = (record) => {
    return record.key === this.state.editingKey;
  };

  precise(x) {
    // console.log(Number.parseFloat(x)<10);
    // console.log(typeof x !== 'number');
    if(typeof parseFloat(x) !== 'number'){
      // console.log(parseFloat(x));
      return Number.parseFloat('0.0').toPrecision(2);
    }else{
      if(Number.parseFloat(x)<10){
          return Number.parseFloat(x).toPrecision(2);
      }else{
          return Number.parseFloat(x).toPrecision(3);
      }
    }
  }

  // merge savedData with selectedRows
  // update parent component
  saveAll = () => {
    let _arr = [];
    if(this.state.selectedRows.length !== this.savedData.length){

      for(let i = 0; i<this.savedData.length; i++){
        for (let j = 0; j < this.state.selectedRows.length; j++){

          if(this.savedData[i].key === this.state.selectedRows[j].key){
            _arr.push(this.savedData[i]);
            break;
          }
          
          // ignoring this condition...
          // else if (this.savedData[i].key !== this.state.selectedRows[j].key){
          //     if(this.savedData[i].minus1 !== '0.0' || this.savedData[i].minus2 !== '0.0' || this.savedData[i].plus1 !== '0.0' || this.savedData[i].plus2 !== '0.0'){
          //         _arr.push(this.savedData[i]);
          //         break;
          //     }
          // }
        }
      }
      this.props.updateParameters({
        selectedIsobaricTable: _arr,
        isobaricTable: this.savedData
      });
    }else{
      this.props.updateParameters({
        selectedIsobaricTable: this.savedData,
        isobaricTable: this.savedData
      });
    }
    this.setState({rowChanged:false});
  }

  render(){
    // console.log(this.props); // [,,]
    // console.log(this.state); // [{},{}]
    // console.log(this.savedData); // [{}, {}]
    // conver into dataSource format for <Table>

    const {rowChanged, sumError, dataSource} = this.state;
    
    return(
      <div style={{width: '100%', margin: '40px auto'}}>
        {
          sumError
          &&
          <Alert
            message="Error"
            description="The sum of all four columns can NOT be larger than 100%."
            type="error"
            showIcon
          />
        }
        <div style={{marginBottom:'25px', marginTop: '25px'}}>
        {
          rowChanged
          &&
          <Button type="primary"
            onClick={this.saveAll}
          >Save Changes</Button>
        }
        {
          !rowChanged
          &&
          <Button type="primary" disabled={true}>Save Changes</Button>
        }
        </div>
        <Table 
          rowSelection={this.rowSelection}
          dataSource={dataSource} 
          columns={this.columns}
          pagination={false}
        />
      </div>
    )
  }
}

export default MyTable;


// the default data format
// const dataSource = [
//     {
//         key: '1',
//         tags: 'iTRAQ4plex-Nter 114',
//         minus2: '0.0',
//         minus1: '0.0',
//         plus1: '0.0',
//         plus2: '0.0'
//     },
//     {
//         key: '2',
//         tags: 'iTRAQ4plex-Nter 115',
//         minus2: '0.0',
//         minus1: '0.0',
//         plus1: '0.0',
//         plus2: '0.0'
//     },
//     {
//         key: '3',
//         tags: 'iTRAQ4plex-Nter 116',
//         minus2: '0.0',
//         minus1: '0.0',
//         plus1: '0.0',
//         plus2: '0.0'
//     },
//     {
//         key: '4',
//         tags: 'iTRAQ4plex-Nter 117',
//         minus2: '0.0',
//         minus1: '0.0',
//         plus1: '0.0',
//         plus2: '0.0'
//     },
// ];